import { render } from "./leftTopit.vue?vue&type=template&id=6d5fd3c8&scoped=true&ts=true"
import script from "./leftTopit.vue?vue&type=script&lang=ts"
export * from "./leftTopit.vue?vue&type=script&lang=ts"

import "./leftTopit.vue?vue&type=style&index=0&id=6d5fd3c8&lang=less&scoped=true"

import exportComponent from "/home/npm/produce/project/yuanYaExam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5fd3c8"]])

export default __exports__